import { useQuery } from 'urql';
import { GetMagazinContentDocument } from '@packages/gql/generated/shopping/GetMagazinContentDocument';
import { useMemo } from 'react';
import { logger } from '@packages/shared/src/utils/logger/logger';

/* GraphQL */ `
  query GetMagazinContent($tag: String!, $limit: Int) {
    getMagazinContent(tag: $tag, limit: $limit) {
      id
      description
      headline
      teaser_image {
        id
        url
        alt
        title
        width
        height
      }
      path
      taxonomy_terms
    }
  }
`;

export const useRelatedContentGql = (tag: string, limit?: number) => {
  const [{ data, error, fetching }] = useQuery({
    query: GetMagazinContentDocument,
    variables: { tag, limit },
    context: useMemo(() => ({ suspense: false }), []),
  });
  if (error) {
    logger.error(`Error fetching related content: ${error.message}`);
    return { error };
  }
  return { fetching, relatedContentData: data?.getMagazinContent || [] };
};
